import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-read-summary-error',
  templateUrl: './read-summary-error.component.html',
  styleUrls: ['./read-summary-error.component.scss']
})
export class ReadSummaryErrorComponent {
  assetsUrl = environment.assetsUrl;
  private url = 'https://www.avvillas.com.co/';
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/notification.svg',
    image: 'close-icon',
    title: 'La transacción ha sido exitosa',
    bullets: [
      'Te llegará un correo confirmando que tu transacción fue exitosa.',
      'Tu CDT se verá reflejado en tus Canales Digitales en máximo 5 días hábiles.'
    ],
    link: {
      url: this.url,
      text: 'Entendido'
    }
  };
}
